import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';

import { ITab } from 'coreOld/types';

import TabsNavigationView from './TabsNavigationView';

interface IProps {
  tabs: ITab[];
  activeTab: ITab;
  setActiveTab: Dispatch<SetStateAction<ITab>>;
}

const TabsNavigation = ({ tabs, activeTab, setActiveTab }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState<number | undefined>(isOpen ? undefined : 0);

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen) {
      setHeight(ref.current?.getBoundingClientRect().height);

      return;
    }

    setHeight(0);
  }, [isOpen, ref.current]);

  return (
    <TabsNavigationView
      tabs={tabs}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      setIsOpen={setIsOpen}
      height={height}
      ref={ref}
    />
  );
};

export default TabsNavigation;
